import { Injectable } from '@angular/core';
import _ from 'lodash';
import { ModeModelBase } from '../model';
import { ModelAccessorBase, ModelAccessorInjectables } from '../model_accessor';

const buildMembership = (groupMembership) => {
  return groupMembership.member().then((member) => {
    groupMembership.accountMember = member;
    return groupMembership;
  });
};
export class GroupMembershipModel extends ModeModelBase {
  override _name = 'groupMembership';
  override idAttribute = 'token';
  override belongsTo = 'group';
  override parentIdAttribute = 'token';
  override attributes = [
    { name: 'email', default: '' },
    { name: 'member_token', default: '' },
  ];
  override hasOne = [{ name: 'account', as: 'member', idAttribute: 'token' }];
}

@Injectable({ providedIn: 'root' })
export class GroupMembershipModelAccessor extends ModelAccessorBase<GroupMembershipModel> {
  override name = 'groupMembership';
  override idAttribute = 'token';
  override parentModel = 'group';
  override parentIdAttribute = 'token';
  override createAttributes = ['group'];

  constructor(injectables: ModelAccessorInjectables) {
    super(injectables, 'migrated', 'mode.groupMembership');
  }

  buildMembershipsWithAccount(groupMemberships) {
    return this.injectables.$q.all(_.map(groupMemberships, buildMembership));
  }
  createModel(resource, opts?) {
    const model = new GroupMembershipModel(this.injectables.modelInjectables);
    model.$initialize(resource, opts);
    return model;
  }
}
